import React from 'react'
import { ImageLoader } from '@usap/uicomponents'
import { disableStyle } from '../constant'
import { Container } from "../../style/ItemImageWMO.css"

const ItemImageWMO = props => {
  const {
    imageHeight,
    itemOrderId,
    eligibleRMA,
    imageUrlSrc,
    imageText,
    multipleItemsPresent,
  } = { ...props }

  return (
    <Container
      style={eligibleRMA ? null : disableStyle}
      alignSelf="start"
      justify="center"
      height={imageHeight}
      multipleItemsPresent={multipleItemsPresent}
    >
      <ImageLoader
        key={`RMA${itemOrderId}`}
        width="100%"
        height="100%"
        src={imageUrlSrc}
        fit="contain"
        alt={imageText}
        cloudinaryParams="h_125,w_125"
        fallback="https://cld.partsimg.com/image/upload/noimage.jpg"
      />
    </Container>
  )
}

export default ItemImageWMO
